import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages.tsx';

export const ProjectLeftIcon = ({ url, name }: { url: string; name: string }) => {
	const { formatMessage } = useIntl();
	return (
		<img
			src={url}
			alt={formatMessage(messages.issueIconAltText, {
				name,
			})}
			height="16"
		/>
	);
};
